import React, { useEffect, useId, useRef, useState } from "react";

/**
 * 折りたたみセクション（高さアニメーション＋フェード）
 */
export default function CollapsibleSection({ title, defaultOpen = true, children }) {
  const [open, setOpen] = useState(defaultOpen);
  const [animating, setAnimating] = useState(false);
  const sectionId = useId();
  const headingId = `${sectionId}-heading`;
  const panelId = `${sectionId}-panel`;
  const wrapperRef = useRef(null);

  // open 変更時に高さをアニメーション
  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;

    const current = el.getBoundingClientRect().height;          // 現在の高さ
    const target = open ? el.scrollHeight : 0;                   // 目標の高さ
    // いったん固定高さにしてから遷移
    el.style.height = `${current}px`;
    el.style.overflow = "hidden";

    requestAnimationFrame(() => {
      setAnimating(true);
      el.style.height = `${target}px`;
      // フェード用クラスも切替
      if (open) el.classList.add("is-opening");
      else el.classList.remove("is-opening");
    });

    const onEnd = () => {
      setAnimating(false);
      el.style.overflow = open ? "visible" : "hidden";
      el.style.height = open ? "auto" : "0px";
      el.removeEventListener("transitionend", onEnd);
    };
    el.addEventListener("transitionend", onEnd);
  }, [open]);

  return (
    <section className="manual-section" aria-labelledby={headingId}>
      <h2
        id={headingId}
        className="manual-heading"
        role="button"
        tabIndex={0}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen(v => !v)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setOpen(v => !v);
          }
        }}
      >
        <span>{title}</span>
        <span className="toggle-indicator">{open ? "▲" : "▼"}</span>
      </h2>

      {/* ラッパー: 高さをアニメーション */}
      <div
        id={panelId}
        ref={wrapperRef}
        className={`manual-panel-wrapper ${open ? "open" : "closed"} ${animating ? "animating" : ""}`}
        role="region"
        aria-labelledby={headingId}
        style={{ height: open ? "auto" : 0 }}
      >
        {/* 中身: ふわっとフェード＆スライド */}
        <div className="manual-panel">
          {children}
        </div>
      </div>
    </section>
  );
}